import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrcamentosEPacotesInserirRoutingModule } from './orcamentos-e-pacotes-inserir-routing.module';
import { OrcamentosEPacotesInserirComponent } from './orcamentos-e-pacotes-inserir.component';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { InputMaskModule } from 'primeng/inputmask';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';


@NgModule({
  declarations: [
    OrcamentosEPacotesInserirComponent
  ],
  imports: [
    CommonModule,
    OrcamentosEPacotesInserirRoutingModule,
    FormsModule,
    TableModule,
    InputTextModule,
    DividerModule,
    MessagesModule,
    DialogModule,
    CalendarModule,
    DropdownModule,
    InputNumberModule,
    ProgressSpinnerModule,
    TooltipModule,
    InputMaskModule,
    FormatPipeModule,
    ConfirmDialogModule
  ],
  providers: [ConfirmationService]
})
export class OrcamentosEPacotesInserirModule { }
